import React from 'react';
import { Typography } from '@mui/material';

export default ({ label }) => (label ? <Typography fontWeight={'bold'}>{label}</Typography> : <React.Fragment />);
